// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesSort-cls1_9Qa","cls2":"ArticlesSort-cls2_zsI ArticlesSort-cls1_9Qa"};